import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// THUNK
export const getAssistanceRequestsList = createAsyncThunk(
    'assistanceRequests/getAssistanceRequests',
    async ({ accountId, token, customerId, systemId, length, start, search }, { rejectWithValue }) => {
        try {
            // Logica di crittografia della password
            const url = `${import.meta.env.VITE_API_BASE_URL}/assistanceRequests/assistanceRequestsList?accountId=${accountId}&customerId${customerId}&systemId${systemId}&length=${length}&start=${start}&search=${search}`;
            console.log('URL: ', url)
            const headers = {
                'Content-Type': 'application/json',
                'auth-token': token
            };
            const options = { method: 'GET', headers };
            const response = await fetch(url, options);
            if (!response.ok) {
                const error = await response.json();
                return rejectWithValue({
                    message: error.message || `Errore sconosciuto.`
                })
            }
            const result = await response.json();
            return result
        } catch (error) {
            return rejectWithValue({
                message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
            });
        }
    })

const initialState = {
    data: null,
    isLoading: false,
    error: null
};

const assistanceRequestsSlice = createSlice({
    name: 'assistanceRequests',
    initialState,
    reducers: {
        clearAssistanceRequestsData: (state) => {
            state.data = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAssistanceRequestsList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAssistanceRequestsList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null
                state.isLoading = false;
            })
            .addCase(getAssistanceRequestsList.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento di assistance requests list.";
                state.isLoading = false;
            })
    }
});

// Selector
export const selectAssistanceRequestsData = (state) => state.assistanceRequests.data;
export const selectAssistanceRequestsLoading = (state) => state.assistanceRequests.isLoading;
export const selectAssistanceRequestsError = (state) => state.assistanceRequests.error;

export const { clearAssistanceRequestsData } = assistanceRequestsSlice.actions;
export default assistanceRequestsSlice.reducer;
